import request from '@/utils/request'
import type { AcsResult, LoginResult, UserInfoResult } from '@/api/types'

export function login(username: string, password: string, code?: string, uuid?: string) {
  return request<AcsResult<LoginResult>>({
    url: '/user/login',
    method: 'post',
    headers: { isToken: false },
    data: { username, password, code, uuid },
  })
}

export function getInfo() {
  return request<AcsResult<UserInfoResult>>({
    url: '/user/getInfo',
    method: 'get',
  })
}

export function logout() {
  return request<AcsResult<unknown>>({
    url: '/user/logout',
    method: 'post',
  })
}

export function getCaptcha() {
  return request<AcsResult<{ img?: string; uuid?: string; captchaEnabled?: boolean }>>({
    url: '/user/getCaptcha',
    method: 'get',
    headers: { isToken: false },
  })
}

export function setLicense(data: { license: string }) {
  return request<AcsResult<unknown>>({
    url: '/user/setLicense',
    method: 'post',
    params: { license: data.license },
  })
}

export function getMachineCode() {
  return request<AcsResult<string>>({
    url: '/user/machineCode',
    method: 'get',
  })
}
